import { render } from "./EducationView.vue?vue&type=template&id=30849de2"
import script from "./EducationView.vue?vue&type=script&lang=js"
export * from "./EducationView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__